import { defineStore } from 'pinia'
import { ITheme } from '@/store/theme/interface'
import cache from '@/utils/cache'
import { useDictTypeAllApi } from '@/api/sys/dict'
import { handleThemeStyle } from '@/utils/theme'

export const useAppStore = defineStore('appStore', {
	state: () => ({
		// sidebar 是否展开
		sidebarOpened: cache.getSidebarOpened(),
		// 国际化
		language: cache.getLanguage() || 'zh-CN',
		// 组件大小
		componentSize: cache.getComponentSize(),
		// 字典列表
		dictList: cache.getDictList(),
		// 主题
		theme: cache.getTheme()
	}),
	actions: {
		setSidebarOpened() {
			this.sidebarOpened = !this.sidebarOpened
			cache.setSidebarOpened(this.sidebarOpened)
		},
		setSidebarStatus(status: boolean) {
			this.sidebarOpened = status
			cache.setSidebarOpened(this.sidebarOpened)
		},
		setLanguage(locale: string) {
			this.language = locale
			cache.setLanguage(locale)
		},
		setComponentSize(size: string) {
			this.componentSize = size
			cache.setComponentSize(size)
		},
		async getDictListAction() {
			const { data } = await useDictTypeAllApi()
			this.dictList = data || []
			cache.setDictList(this.dictList)
		},
		setTheme(theme: ITheme, persist = true) {
			this.theme = theme
			if (persist) {
				cache.setTheme(theme)
			}
		},
		setThemeType(themeType: string) {
			this.theme.themeType = themeType

			// 根据主题类型设置默认颜色
			if (themeType === 'light') {
				this.theme.primaryColor = '#11C26D' // 绿色
			} else if (themeType === 'bluex') {
				this.theme.primaryColor = '#409eff' // 蓝色
			}

			// 更新 data-theme 属性
			document.documentElement.setAttribute('data-theme', themeType)

			// 处理暗黑模式状态
			if (themeType === 'dark') {
				document.documentElement.classList.add('dark')
				this.theme.isDark = true
			} else {
				document.documentElement.classList.remove('dark')
				this.theme.isDark = false
			}

			handleThemeStyle(this.theme)
			cache.setTheme(this.theme)
		},
		handleDarkModeChange(isDark: boolean) {
			if (isDark) {
				document.documentElement.classList.add('dark')
				document.documentElement.setAttribute('data-theme', 'dark')
				this.theme.themeType = 'dark'
				this.theme.isDark = true
			} else {
				document.documentElement.classList.remove('dark')
				if (this.theme.themeType === 'dark') {
					this.theme.themeType = 'light'
					this.theme.primaryColor = '#11C26D' // 默认绿色
					document.documentElement.setAttribute('data-theme', 'light')
				} else {
					document.documentElement.setAttribute('data-theme', this.theme.themeType)
				}
				this.theme.isDark = false
			}
			handleThemeStyle(this.theme)
			cache.setTheme(this.theme)
		}
	}
})
